import React from 'react';
import { useUIStore } from '@/store';
import './Footer.css';

type Props = {
  currentYear: number;
  currentVersion: string;
};

const SidebarFooter: React.FC<Props> = ({ currentYear, currentVersion }) => {
  const { sidebarCollapsed: collapsed } = useUIStore();

  return (
    <div
      className={`sidebar-footer ${collapsed ? 'sidebar-footer--collapsed' : ''}`}
    >
      <div className="sidebar-footer__content">
        <div>Version {currentVersion}</div>
        <div>&copy; {currentYear} Sumitronics</div>
      </div>
    </div>
  );
};

export default SidebarFooter;
